import * as React from 'react'
import {
  Box,
  useColorModeValue as mode,
} from '@chakra-ui/react'
import Layout from '../components/website/Layout'
import Headers from '../components/website/sections/Header/'
import { CourseHero } from '../components/website/legacy/CourseHero'
import { CourseSyllabus } from '../components/website/legacy/syllabus/CourseSyllabus'
import { Pricing } from '../components/website/legacy/pricing/Pricing'
import { Teacher } from '../components/website/legacy/Teacher'
import { LearnDataScience } from '../components/website/legacy/features/LearnDataScience'
import Faq from '../components/website/legacy/Faq'
import Footer from '../components/website/sections/Footer'

const PythonEssentials = () => {
  return (
    <Layout
      title="Jungle Program – Python Essentials for Data Science"
      canonical="https://www.jungleprogram.com/data-science-live-course"
      description="Join a 4-week part-time training to practice and gain strong foundations in data science."
    >
      <Headers />
      <Box bg={mode('gray.50')} pt="5" pb="0" mb="0" overflow="hidden">
        <CourseHero
          level='Beginner'
          duration='4 weeks part time'
          instructor={`Negar Vahid`}
          instructorImg={`/img/instructor-negar.png`}
          courseName={`Python Essentials for
          Data Science`}
          dates={`May 2022`}
          desc={<div>
            <p>
              Join a 4-week part-time training to practice all the Python essentials you need to start your journey in data science.
            </p>
            <p>
              Do you fancy using data science in your career, but have always brushed off the thought of learning it and didn't know where to start?
            </p>
            <p>
              This course is designed for you. We'll go through all the Python you'll need and get a taste of data science at the same time. 
            </p>
          </div>}
          enroll={`https://calendly.com/gauroq/first-call-jungle-program?a1=I'm%20interested%20in:%20Python%20Essentials`}
        />
        <LearnDataScience
          title={`Learn Python
          Programming`}
          who={`This program is for data enthusiasts who want to gain strong foundations in data science, but who need an introduction, or a refresher in, Python programming or core data science concepts.`}
          requirements={`No prior coding experience is required, but to be successful, we recommend that learners are already proficient in high-school-level mathematics and are eager to learn more advanced concepts where necessary.`}
        />
        <CourseSyllabus
          overview={
            {
              'title': 'Detailed course program',
              'subtitle': '',
              'features': [
                'First, you will get comfortable with python by understanding its basic functionalities.',
                'Next stop, you will take a first step to use logic to solve basic yet real-life data science problems.',
                'After that, you will learn how to handle files and strings, and using dictionaries to sort out your data.',
                'Finally, you\'ll work on your final project and re-enforce all the wonderful things you\'ve learned in the past weeks.',
              ]
            }
          }
          chapters={
            [
              {
                date: 'Week 1',
                name: `Python Basics:
                Control Flow and Lists`,
                desc: 'Hello World! This chapter teaches you how to control the flow of your program and comfortably use python lists.',
                features: [
                  {
                    name: 'Python Basics',
                    desc: `Getting a little comfortable with Python by getting to know its basic functionalities.
                    • Hello World!
                    • Data Types`
                  },
                  {
                    name: 'Conditionals Pt. 1',
                    desc: `Taking the first step to logic and controlling the flow of our program:
                    • Introduction to Control Flow
                    • if/else
                    • else if`
                  },
                  {
                    name: 'Conditionals Pt. 2',
                    desc: `Deep dive into python lists:
                    • Indexing In Lists 
                    • Slicing
                    • Range 
                    • Sorting 
                    • Tuples 
                    • List Comprehensions
                    • Essential Methods in lists`
                  },
                  {
                    name: 'Numpy Arrays',
                    desc: `• Ndarray Arithmetics
                    • 2D Arrays
                    • 2D Arithmetics`
                  }
                ]
              },
              {
                date: 'Week 2',
                name: `Loops and functions`,
                desc: `We’ll go through two of the most important programming concepts:
                loops and functions! Learn how to reuse your code.`,
                features: [
                  {
                    name: 'For Loops',
                    desc: `For Loops are structures that let you repeat Python code over and over:
                    • For loops introduction 
                    • Using Range in for loops
                    • Nested for loops`
                  },
                  {
                    name: 'While Loops',
                    desc: `• While loops introduction 
                    • Infinite loops
                    • Break and Continue Statements`
                  },
                  {
                    name: 'Functions',
                    desc: `Learn about code reuse with Python functions:
                    • Why do we need functions?
                    • Defining A Function
                    • Function Parameters 
                    • Return Statements`
                  }
                ]
              },
              {
                date: 'Week 3',
                name: `Strings and Dictionaries`,
                desc: `Handling Our Data: Learn how to work with data in an automated way, and how to manipulate strings like a pro. We'll also tap into "dictionaries" and learn how we can use them to organize our data.`,
                features: [
                  {
                    name: 'Strings',
                    desc: `• Iterating through Strings
                    • Regex Essentials 
                    • Using Modules`
                  },
                  {
                    name: 'Dictionaries',
                    desc: `• Why use dictionaries?
                    • Indexing 
                    • Key-value pairs
                    • Manipulating the data inside of a dictionary`
                  }
                ]
              },
              {
                date: 'Week 4',
                name: `Pandas + Final Project`,
                desc: `This week is dedicated to exploring the Pandas module, file handling, and working on the final project to test your hands-on data science skills using Python.`,
                features: [
                  {
                    name: 'Pandas',
                    desc: `• Series 
                    • Dataframes 
                    • Inspect a DataFrame
                    • Selecting Rows and columns with Logic
                    • Using lambda functions to calculate complex quantities`
                  },
                  {
                    name: 'Handling Files',
                    desc: `• "with" Method 
                    • "glob" Method
                    • "os.path" Method
                    • Reading a CSV file`
                  },
                  {
                    name: 'Lambda functions',
                    desc: ``
                  }
                ]
              }
            ]
          }
        />
        <Teacher
          name={`Negar Vahid`}
          desc={<div>
            <p>
              Negar is the founder and CTO of Elaratech, an AI-focused startup based in Tbilisi, Georgia. She has taught Introduction To Python and Flask Web Development at Ilia State University since 2019.
            </p>
            <p>
              Negar is a Python evangelist that started as a Full Stack Python Developer before moving on to data engineering and then Machine Learning Engineer.
            </p>
            <p>
              Her prior experience with Python and a decent grasp of maths helped her make the switch to data science very easily.
            </p>
          </div>}
          image={`./img/instructor-negar-2.jpg`}
          linkedin={`https://www.linkedin.com/in/negar-vahid-347ab3193/`}
        />
        <Pricing
          name="Python Essentials for Data Science"
          price="390"
          pricestroke=""
          duration="Next training: May 2022"
          link="https://calendly.com/gauroq/first-call-jungle-program?a1=I'm%20interested%20in:%20Python%20Essentials"
          features={
            [
              'Part-time training',
              'Join a micro-class of < 10 students',
              'Compatible with your full-time job',
              '3 hours of live interactive class per week',
              '3 to 5 hours of coding exercises per week',
              'Demo day & certification of course completion',
              'Connect with other students and learn together',
              'Master the latest tools & languages in Python',
              '1:1 calls with the teachers',
              '5-day free trial',
              'Eligible to CPF financing in France 🇫🇷'
            ]
          }
        />
        <Faq price="390" />
        <Footer />
      </Box>
    </Layout>
  )
}

export default PythonEssentials